// The game card's starting-QB flag: "⚠ QB Q" after the ATS record when a
// team's starter is on the injury report.
//
// Context, never an input to the edge. A market move driven by QB news is
// still the market's number; the flag only says the frozen line missed real
// news rather than noise. Who counts as the starter is decided server-side
// (Espn::StartingQbInjuries) and the payload is null whenever that is not
// known, so there is nothing to guess here either: any status outside the
// table below renders nothing.
const FLAGS = {
  Questionable: { label: "QB Q", tone: "text-amber-300" },
  Doubtful: { label: "QB D", tone: "text-amber-300" },
  Out: { label: "QB OUT", tone: "text-red-400" },
};

// `injury` is the server's {name, status}, or null. Returns null for nothing
// to show, else {label, tone, title}.
export function qbInjuryFlag(injury) {
  const flag = injury ? FLAGS[injury.status] : null;
  if (!flag) return null;

  const title = injury.name ? `${injury.name} — ${injury.status}` : injury.status;
  return { ...flag, title };
}
